const MousewheelUtil = require('../utils/Mousewheel');
const TouchSupport = require('../utils/TouctSupport');
const SizesUtils = require('../utils/SizesUtils');
const Utils = require('../utils/utils');

const win = window;
const doc = document;

function Key(keyCode) {
    const key = {
        code: keyCode,
        isPressed: false,
        press: void 0,
        release: void 0,
        hold: void 0
    };

    key.onHold = function () {
        const key = this;
        if (!key.isPressed) return;
        key.hold();
        win.requestAnimationFrame(() => { key.onHold.apply(key); });
    }

    key.downHandler = function (evt) {
        const key = this;
        if (evt.keyCode === key.code) {
            if (key.isPressed) return;
            key.isPressed = true;
            if (key.press) key.press();
            if (key.hold) {
                key.onHold.apply(key);
            }

            evt.preventDefault();
        }
    };

    key.upHandler = function (evt) {
        const key = this;
        if (evt.keyCode === key.code) {
            if (!key.isPressed) return;
            key.isPressed = false;
            if (key.release) key.release();

            evt.preventDefault();
        }
    };


    return key;
}

function Keyboard() {
    const keyboard = {
        enabled: false,
        keys: {
            up: Key(38),
            down: Key(40),
            pageUp: Key(33),
            pageDown: Key(34)
        },
        enable: function enable() {
            const control = this;
            if (control.keyboard.enabled) { return; }

            const keys = control.keyboard.keys;
            for (const s in keys) {
                if (!keys.hasOwnProperty(s)) continue;
                keys[s].hold = control.keyboard[s];
                keys[s].release = control.keyboard[s + 'Release'];
            }

            // Attach event listeners
            win.addEventListener('keydown', control.keyboard.downHandler, false);
            win.addEventListener('keyup', control.keyboard.upHandler, false);
            control.keyboard.enabled = true;
        },
        disable: function enable() {
            const control = this;
            if (!control.keyboard.enabled) { return; }
            win.removeEventListener('keydown', control.keyboard.downHandler, false);
            win.removeEventListener('keyup', control.keyboard.upHandler, false);
            control.keyboard.enabled = false;
        },
        downHandler: function downHandler(evt) {
            const control = this;
            const keys = control.keyboard.keys;
            let key;
            for (const s in keys) {
                if (!keys.hasOwnProperty(s)) continue;
                key = keys[s];
                key.downHandler.apply(keys[s], [evt]);
            }
        },
        upHandler: function upHandler(evt) {
            const control = this;
            const keys = control.keyboard.keys;
            for (const s in keys) {
                if (!keys.hasOwnProperty(s)) continue;
                keys[s].upHandler.apply(keys[s], [evt]);
            }
        },
        increment: function (state, value) {
            const control = this;
            control.keyboard.lastTime = (new window.Date()).getTime();
            control.target.setState(state);
            control.target.increment(value);
        },
        up: function () {
            const control = this;
            control.keyboard.increment('short', -control.params.keyboard.step);
        },
        upRelease: function () {
            const control = this;
            const timeDiff =  (new window.Date()).getTime() - control.keyboard.lastTime;
            control.keyboard.increment('slowDown', -control.params.keyboard.step * 300 * control.params.keyboard.inertiaRatio * timeDiff / 1000);
        },
        down: function () {
            const control = this;
            control.keyboard.increment('short', control.params.keyboard.step);
        },
        downRelease: function () {
            const control = this;
            const timeDiff =  (new window.Date()).getTime() - control.keyboard.lastTime;
            control.keyboard.increment('slowDown', control.params.keyboard.step * 300 * control.params.keyboard.inertiaRatio * timeDiff / 1000);
        },
        pageUp: function () {
            const control = this;
            control.keyboard.increment('short', -control.params.keyboard.pageStep);
        },
        pageUpRelease: function () {
            const control = this;
            control.keyboard.increment('slowDown', -control.params.keyboard.pageStep * control.params.keyboard.inertiaRatio);
        },
        pageDown: function () {
            const control = this;
            control.keyboard.increment('short', control.params.keyboard.pageStep);
        },
        pageDownRelease: function () {
            const control = this;
            control.keyboard.increment('slowDown', control.params.keyboard.pageStep * control.params.keyboard.inertiaRatio);
        }
    };

    return {
        create: function create(control, key) {
            const p = {};
            p[key] = {
                lastTime: 0,
                enabled: keyboard.enabled,
                keys: keyboard.keys,
                enable: keyboard.enable.bind(control),
                disable: keyboard.disable.bind(control),
                downHandler: keyboard.downHandler.bind(control),
                upHandler: keyboard.upHandler.bind(control),
                increment: keyboard.increment.bind(control),
                up: keyboard.up.bind(control),
                upRelease: keyboard.upRelease.bind(control),
                down: keyboard.down.bind(control),
                downRelease: keyboard.downRelease.bind(control),
                pageUp: keyboard.pageUp.bind(control),
                pageUpRelease: keyboard.pageUpRelease.bind(control),
                pageDown: keyboard.pageDown.bind(control),
                pageDownRelease: keyboard.pageDownRelease.bind(control)
            };
            Utils.extend(control, p);
        }
    }
}

function Mousewheel() {
    const mousewheel = {
        enabled: false,
        enable: function enable() {
            const control = this;
            if (control.mousewheel.enabled) { return; }
            doc.addEventListener(MousewheelUtil.event, control.mousewheel.handle);
            control.mousewheel.enabled = true;
        },
        disable: function enable() {
            const control = this;
            if (!control.mousewheel.enabled) { return; }
            doc.removeEventListener(MousewheelUtil.event, control.mousewheel.handle);
            control.mousewheel.enabled = false;
        },
        handle: function handle(evt) {
            const control = this;
            let e = evt;
            if (e.originalEvent) { e = e.originalEvent; }
            const data = MousewheelUtil.normalize(e);
            let delta = 0;
            if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
            if (delta === 0) { return true; }

            const clear = () => {
                if (control.mousewheel.timeout === void 0) return;
                clearTimeout(control.mousewheel.timeout);
                control.mousewheel.timeout = void 0;
            }

            clear();

            const t = (new win.Date()).getTime();
            const value = delta * control.params.mousewheel.ratio;

            control.target.setState('short');
            control.target.increment(value);
            control.mousewheel.lastTime = t;

            control.mousewheel.timeout = setTimeout(() => {
                clear();
                control.target.setState('slowDown');
                control.target.increment(value * 0.5 * control.params.mousewheel.inertiaRatio);
                control.mousewheel.lastTime = (new win.Date()).getTime();
            }, 120);

            if (e.preventDefault) { e.preventDefault(); } else { e.returnValue = false; }
        }
    };

    return {
        create: function create(control, key) {
            const p = {};
            p[key] = {
                lastTime: 0,
                enabled: mousewheel.enabled,
                enable: mousewheel.enable.bind(control),
                disable: mousewheel.disable.bind(control),
                handle: mousewheel.handle.bind(control)
            };
            Utils.extend(control, p);
        }
    }
}

function Touch() {
    const touch = {
        enabled: false,
        enable: function enable() {
            const control = this;
            if (control.touch.enabled) { return; }

            const onTouchStart = control.touch.onTouchStart;
            const onTouchMove = control.touch.onTouchMove;
            const onTouchEnd = control.touch.onTouchEnd;

            if (!TouchSupport.touch && (TouchSupport.support.pointerEvents || TouchSupport.support.prefixedPointerEvents)) {
                document.addEventListener(TouchSupport.touchEvents.start, onTouchStart, false);
                document.addEventListener(TouchSupport.touchEvents.move, onTouchMove, false);
                document.addEventListener(TouchSupport.touchEvents.end, onTouchEnd, false);
            } else {
                if (TouchSupport.support.touch) {
                    const passiveListener = false;
                    document.addEventListener(TouchSupport.touchEvents.start, onTouchStart, passiveListener);
                    document.addEventListener(TouchSupport.touchEvents.move, onTouchMove, false);
                    document.addEventListener(TouchSupport.touchEvents.end, onTouchEnd, passiveListener);
                }
                if (!TouchSupport.device.ios && !TouchSupport.device.android || !TouchSupport.support.touch && TouchSupport.device.ios) {
                    document.addEventListener('mousedown', onTouchStart, false);
                    document.addEventListener('mousemove', onTouchMove, false);
                    document.addEventListener('mouseup', onTouchEnd, false);
                }
            }
            control.touch.enabled = true;

        },
        disable: function enable() {
            const control = this;
            if (!control.touch.enabled) { return; }
            const onTouchStart = control.touch.onTouchStart;
            const onTouchMove = control.touch.onTouchMove;
            const onTouchEnd = control.touch.onTouchEnd;

            if (!TouchSupport.touch && (TouchSupport.support.pointerEvents || TouchSupport.support.prefixedPointerEvents)) {
                document.removeEventListener(TouchSupport.touchEvents.start, onTouchStart, false);
                document.removeEventListener(TouchSupport.touchEvents.move, onTouchMove, false);
                document.removeEventListener(TouchSupport.touchEvents.end, onTouchEnd, false);
            } else {
                if (TouchSupport.support.touch) {
                    const passiveListener = false;
                    document.removeEventListener(TouchSupport.touchEvents.start, onTouchStart, passiveListener);
                    document.removeEventListener(TouchSupport.touchEvents.move, onTouchMove, false);
                    document.removeEventListener(TouchSupport.touchEvents.end, onTouchEnd, passiveListener);
                }
                if (!TouchSupport.device.ios && !TouchSupport.device.android || !TouchSupport.support.touch && TouchSupport.device.ios) {
                    document.removeEventListener('mousedown', onTouchStart, false);
                    document.removeEventListener('mousemove', onTouchMove, false);
                    document.removeEventListener('mouseup', onTouchEnd, false);
                }
            }
            control.touch.enabled = false;
        },
        onTouchStart: function handle(evt) {
            const control = this;
            let e = evt;
            if (e.originalEvent) { e = e.originalEvent; }
            if (TouchSupport.device.android) { e.preventDefault(); }
            const touches = control.touch.touches;
            touches.isTouched = true;
            touches.isTouchEvent = e.type === 'touchstart';
            touches.currentX = touches.startX = touches.isTouchEvent ? e.targetTouches[0].pageX : e.pageX;
            touches.currentY = touches.startY = touches.isTouchEvent ? e.targetTouches[0].pageY : e.pageY;
            touches.touchStartTime = touches.touchTime = (new window.Date()).getTime();
        },
        onTouchMove: function (evt) {
            let e = evt;
            const control = this;
            const touches = control.touch.touches;

            if (!touches.isTouched) return;
            if (e.originalEvent) { e = e.originalEvent; }
            if (touches.isTouchEvent && e.type !== 'touchmove') return;

            const touchTime = (new window.Date()).getTime();
            const timeDiff = touchTime - touches.touchTime;

            touches.startY = touches.currentY;
            touches.startX = touches.currentX;
            touches.touchTime = touchTime;

            /* const pageX = */touches.currentX = touches.isTouchEvent ? e.targetTouches[0].pageX : e.pageX;
            const pageY = touches.currentY = touches.isTouchEvent ? e.targetTouches[0].pageY : e.pageY;
            // const winW = SizesUtils.winOffsetWidth();
            const winH = SizesUtils.winOffsetHeight();
            const deltaY = touches.currentY - touches.startY;
            // const deltaX = touches.currentX - touches.startX;
            let value = -deltaY * control.params.touch.ratio;

            e.preventDefault();
            e.stopPropagation();

            // Border
            if (
                /* pageX < touches.startY && pageX < 1 ||
                pageX > touches.startY && pageX > winW - 1 ||*/
                pageY < touches.startY && pageY < 1 ||
                pageY > touches.startY && pageY > winH - 1
            ) {
                touches.isTouched = false;

                control.target.setState('set');
                control.target.increment(value);

                control.target.setState('slowDown');
                value = timeDiff > 60 ? value * 8 * control.params.touch.inertiaRatio * timeDiff / 1000 : value * 2 * control.params.touch.inertiaRatio;
                control.target.increment(value);

                return;
            }

            control.target.setState('set');
            control.target.increment(value);
        },
        onTouchEnd: function onTouchEnd(evt) {
            let e = evt;
            const control = this;
            const touches = control.touch.touches;
            if (!touches.isTouched) return;
            if (e.originalEvent) { e = e.originalEvent; }
            const deltaY = touches.currentY - touches.startY;
            // const deltaX = touches.currentX - touches.startX;
            let value = -deltaY * control.params.touch.ratio;

            const touchEndTime = (new window.Date()).getTime();
            let timeDiff = touchEndTime - touches.touchStartTime;
            touches.isTouched = false;

            // TAP
            if (timeDiff < 150) return;

            timeDiff = touchEndTime - touches.touchTime;


            control.target.setState('set');
            control.target.increment(value);

            value = timeDiff > 60 ? value * 8 * control.params.touch.inertiaRatio * timeDiff / 1000 : value * 2 * control.params.touch.inertiaRatio;
            control.target.setState('slowDown');
            control.target.increment(value);
        }
    };

    return {
        create: function create(control, key) {
            const p = {};
            p[key] = {
                lastTime: 0,
                touches: {},
                enabled: touch.enabled,
                enable: touch.enable.bind(control),
                disable: touch.disable.bind(control),
                onTouchStart: touch.onTouchStart.bind(control),
                onTouchMove: touch.onTouchMove.bind(control),
                onTouchEnd: touch.onTouchEnd.bind(control)
            };
            Utils.extend(control, p);
        }
    }
}

const defaults = {
    keyboard: {
        enabled: true,
        step: 200,
        pageStep: 1500,
        inertiaRatio: 1.5
    },
    mousewheel: {
        enabled: true,
        ratio: 1,
        inertiaRatio: 1
    },
    touch: {
        enabled: true,
        ratio: 1,
        inertiaRatio: 1.5
    }
};

const _addPlugin = (control, key, plugin, overwrite) => {

    let p;
    if (plugin !== void 0 && overwrite) {
        p = plugin();
    } else {
        switch (key) {
            case 'keyboard':
                p = Keyboard();
                break;
            case 'mousewheel':
                p = Mousewheel();
                break;
            case 'touch':
                p = Touch();
                break;
            default:
                if (plugin) p = plugin();
                    break;
        }
    }
    if (!p) return;

    p.create(control, key);

    if (control.params[key] && control.params[key].enabled && control[key].enable !== void 0) {
        control._pluginsNames.push(key);
        control[key].enable();
    }
}

const _enablePlugins = function () {
    const control = this;
    let i;
    let p;
    let key;
    for (i = 0; i < control._pluginsNames.length; i++) {
        key = control._pluginsNames[i];
        if (!control.hasOwnProperty(key)) continue;
        p = control[key];
        if (control.params[key] && control.params[key].enabled && p.enable !== void 0)
            p.enable();
    }
}

const _disablePlugins = function () {
    const control = this;
    let i;
    let p;
    let key;
    for (i = 0; i < control._pluginsNames.length; i++) {
        key = control._pluginsNames[i];
        if (!control.hasOwnProperty(key)) continue;
        p = control[key];
        if (control.params[key] && control.params[key].enabled && p.disable !== void 0)
            p.disable();
    }
}

function PseudoScrollControl(target, config) {
    const pseudoScrollControl = {
        target: target,
        params: Utils.extend(defaults, config),
        _pluginsNames: []
    };

    pseudoScrollControl.enable = _enablePlugins.bind(pseudoScrollControl);
    pseudoScrollControl.disable = _disablePlugins.bind(pseudoScrollControl);

    _addPlugin(pseudoScrollControl, 'mousewheel');
    _addPlugin(pseudoScrollControl, 'keyboard');
    _addPlugin(pseudoScrollControl, 'touch');



    return pseudoScrollControl;
}

module.exports = PseudoScrollControl;


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/pseudoScrollControl/PseudoScrollControl.js